import '../styles/components/footer.scss';
import React from 'react';
import { useState } from 'react';

function Footer() {

    const [email,setEmail] = useState("")

    return(
    <footer className="footer-container">
        <div className="footer-content">
            <div className="contents">                
                <table className="spec-table">
                <tbody><tr>
                <th>Title</th>
                <td>Prinny Presents NIS Classics Volume 1: Phantom Brave: The Hermuda Triangle Remastered / Soul Nomad & the World Eaters</td>
                </tr>
                <tr>
                <th>Release</th>
                <td>Aug 31, 2021</td>
                </tr>
                <tr>
                <th>Platform</th>
                <td>Nintendo Switch™
                </td>
                </tr>
                <tr>
                <th>Player(s)</th>
                <td>1</td>
                </tr>
                <tr>
                <th>Genre</th>
                <td>Strategy RPG</td>
                </tr>
                <tr>
                <th>Audio</th>
                <td>Japanese, English</td>
                </tr>
                <tr>
                <th>Text</th>
                <td>English</td>
                </tr>
                <tr>
                <th>Publisher</th>
                <td>NIS America, Inc.</td>
                </tr>
                <tr>
                <th>Developer</th>
                <td>Nippon Ichi Software, Inc.</td>
                </tr>
                </tbody></table>
            </div>

            <div className="social">
                <a href="https://twitter.com/nisamerica" target="_blank" rel="noreferrer" className="track-link" data-label="Twitter"><i className="fab fa-twitter btn" ></i></a>
                <a href="https://www.facebook.com/NISAmericaInc/" target="_blank" rel="noreferrer" className="track-link" data-label="Facebook"><i className="fab fa-facebook-f btn"></i></a>
                <a href="https://www.instagram.com/nisamerica/" target="_blank" rel="noreferrer" className="track-link" data-label="Instagram"><i className="fab fa-instagram btn"></i></a>
                <span style={{whiteSpace: "nowrap"}}><a href="https://www.youtube.com/user/NISAmerica" target="_blank" rel="noreferrer" className="track-link" data-label="YouTube"><i className="fab fa-youtube btn"></i></a>
                <a href="https://www.twitch.tv/nisamerica" target="_blank" rel="noreferrer" className="track-link" data-label="Twitch"><i className="fab fa-twitch btn"></i></a>
                <a href="https://discord.gg/nisa" target="_blank" rel="noreferrer" className="track-link" data-label="Discord"><i className="fab fa-discord btn"></i></a>
                </span>
            </div>

            <div className="mailchimp">
                <form action="https://nisamerica.us11.list-manage.com/subscribe/post?u=e8fc423eff95099d1ffcc6009&amp;id=349f7d20f9" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" target="_blank" noValidate="">
                    <div id="mc_embed_signup_scroll" className="mailchimp">
                        <label for="mce-EMAIL" className="subscribe">Subscribe to our mailing list to get the latest information!</label>
                        <div className="interact">
                            <input type="email" value={email} name="EMAIL" className="email" id="mce-EMAIL" placeHolder="email address" required="" onChange={e => setEmail(e.target.value)}/>
                            <div style={{position:" absolute", left: "-5000px"}}>
                                <input type="text" name="b_e8fc423eff95099d1ffcc6009_349f7d20f9" tabindex="-1" value=""/>
                            </div>
                            <input type="hidden" value="cruelking" name="SIGNSITE" className="" id="mce-SIGNSITE"/>
                            <div className="clear">
                                <input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" className="button"/>
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            <div className="logos">
                <img src="./img/footer/rp_NEW.svg" alt="ESRB RATING" className="f-logo" id="ESRB" height='90'/>
                <img src="./img/footer/Nintendo Switch™.svg" alt="NSW" className="f-logo" id="NSW"/>
                <img src="./img/footer/nis_w.svg" alt="Nippon Ichi Software" className="f-logo" id="NIS"/>
                <a href="http://nisamerica.com/" target="_blank" rel="noreferrer">
                    <img src="./img/footer/NIS_logo.webp" alt="NIS America" className="f-logo fun" id="NISA"/>
                </a>
            </div>
            <p>
                ©2004-2021 Nippon Ichi Software, Inc. ©2021 NIS America, Inc. All rights reserved. Phantom Brave is a trademark or registered trademark of Nippon Ichi Software, Inc.
                <br/>
                Nintendo Switch is a trademark of Nintendo.
                <br/>
                The rating icon is a trademark of the Entertainment Software Association. 
                All other trademarks are properties of their respective owners.
            </p>
        </div>
    </footer>
    )
}

export default Footer;